import { ListItem, ListItemButton, SxProps, Tooltip, TooltipProps } from '@mui/material';
import { alpha } from '@mui/material/styles';
import React, { useState } from 'react';
import { useStyling } from '../Theme';
import type { SecuredActionType } from './ActionType';
import ResponsiveActions from './ResponsiveActions';

type ListMenuProps = {
    renderItemLabel: (item: any) => React.ReactNode;
    securedActions?: SecuredActionType[];
    item?: any;
    onRowClick?: (item: any) => void;
    renderItemTooltip?: (item: any) => React.ReactNode;
    tooltipPlacement?: TooltipProps['placement'];
    iconSx?: SxProps;
    rowSx?: SxProps;
};

export default function ListMenu({
    securedActions = [],
    item,
    renderItemLabel,
    onRowClick,
    renderItemTooltip,
    tooltipPlacement = 'right-start',
    iconSx,
    rowSx
}: ListMenuProps) {
    const { theme } = useStyling();
    const [isHover, setIsHover] = useState(false);

    const renderButton = () => (
        <ListItemButton
            onClick={() => onRowClick?.(item)}
            sx={{
                px: 1.5,
                minHeight: '36px',
                width: '100%',
                pr: 6,
                '&:hover': { backgroundColor: alpha(theme.palette.primary.main, 0.08) }
            }}
        >
            {renderItemLabel(item)}
        </ListItemButton>
    );

    return (
        <ListItem
            disableGutters
            disablePadding
            onMouseEnter={() => setIsHover(true)}
            onMouseLeave={() => setIsHover(false)}
            secondaryAction={
                <ResponsiveActions
                    isActivated={isHover}
                    securedActions={securedActions}
                    showBorder={false}
                    containerSx={{ backgroundColor: 'transparent', px: 0, py: 0 }}
                    iconSx={{ color: theme.palette.grey[650], ...iconSx }}
                />
            }
            sx={{ border: 'none', ...rowSx }}
        >
            {renderItemTooltip ? (
                <Tooltip placement={tooltipPlacement} title={renderItemTooltip(item)} arrow>
                    {renderButton()}
                </Tooltip>
            ) : (
                renderButton()
            )}
        </ListItem>
    );
}
